export default __webpack_public_path__ + "static/media/backinthefray.1053d3d1.png";